import { Box, HStack, Text } from '@chakra-ui/react';
import { useDroppable } from '@dnd-kit/core'
import { SortableContext, horizontalListSortingStrategy } from '@dnd-kit/sortable'
import type { ItineraryAssignmentDto } from '../../../types/campaign'
import { ItineraryAssignmentCard } from './ItineraryAssignmentCard'

interface StaticCellDropZoneProps {
  grantId: string
  assignments: ItineraryAssignmentDto[]
  onRemove?: (assignmentId: string) => void
}

/** The sentinel date string used as the key for static (non-dated) assignments. */
export const STATIC_SENTINEL_KEY = '0001-01-01'

export function StaticCellDropZone({
  grantId,
  assignments,
  onRemove,
}: StaticCellDropZoneProps) {
  const droppableId = `${grantId}:${STATIC_SENTINEL_KEY}`
  const { isOver, setNodeRef } = useDroppable({
    id: droppableId,
    data: { type: 'cell', grantId, dateStr: STATIC_SENTINEL_KEY },
  })

  return (
    <Box
      ref={setNodeRef}
      minH="48px"
      bg={isOver ? 'accent.soft' : 'gray.50'}
      borderRadius="md"
      border="1px solid"
      borderColor={isOver ? 'accent' : 'gray.200'}
      p={1}
      transition="all 0.15s"
      flex={1}
    >
      <SortableContext
        items={assignments.map(a => a.id)}
        strategy={horizontalListSortingStrategy}
      >
        <HStack gap={1} flexWrap="wrap" minH="40px" align="start">
          {assignments.map(assignment => (
            <ItineraryAssignmentCard
              key={assignment.id}
              assignment={assignment}
              onRemove={onRemove}
            />
          ))}
          {assignments.length === 0 && (
            <Text fontSize="2xs" color="gray.400" pt={3} px={2}>
              Drop turfs here
            </Text>
          )}
        </HStack>
      </SortableContext>
    </Box>
  );
}
